/** @format */

import {styled} from '@mui/material/styles';
import {Button} from '@mui/material';

import {SegmentedButtonProps} from './types';

export const Root = styled(Button, {
  shouldForwardProp: prop =>
    prop !== 'size' && prop !== 'active' && prop !== 'activeBgColor',
})<SegmentedButtonProps>(({theme, size, active, activeBgColor}) => ({
  width: 'max-content',
  height: size === 'large' ? '60px' : '48px',
  padding: theme.spacing(0, 4),
  borderRadius: 0,
  transition: '0s',
  background: active ? activeBgColor : theme.palette.figma_surface?.main,
  color: active
    ? theme.palette.semantic_dark?.primary.on
    : theme.palette.figma_surface?.light,
  fontSize: size === 'large' ? '24px' : '16px',
  fontWeight: size === 'large' ? 400 : 500,
  lineHeight: size === 'large' ? '28px' : '20px',
  display: 'flex',
  alignItems: 'center',
  cursor: active ? 'default' : 'pointer',
  userSelect: 'none',
  gap: theme.spacing(1),

  '&:hover': {
    background: active ? activeBgColor : theme.palette.figma_gray_dark_4?.main,
  },
}));
